import { GenericDataApi } from '@/lib/data/GenericDataApi';

export class MeetingGuide extends GenericDataApi<any> {
    constructor() {
        super('Questions');
    }
}

export default new MeetingGuide();
